import { FC, ReactElement } from 'react'
import { Box } from '@mui/system'
import { Loader } from 'components'
import { useAuth } from 'context'
import { useAnalytics } from 'hooks/analytics'
import { Navigate, useLocation } from 'react-router'
import { getRegistrationGateRedirect } from 'screens/NutritionistOnboarding'
import { FeatureGrant, useCurrentUserQuery } from 'types'

interface IPrivateRoute {
  feature: FeatureGrant
  children: ReactElement<any, any>
}

export const PrivateRoute: FC<IPrivateRoute> = ({ feature, children }) => {
  const { isAuthorized, loading } = useAuth()
  const { trackPage } = useAnalytics()
  const location = useLocation()
  const { data: { currentUser } = {} } = useCurrentUserQuery()

  trackPage(location.pathname)

  const redirectTo = getRegistrationGateRedirect({
    registrationStatus: currentUser?.coachProfile?.registrationStatus
  })

  if (redirectTo && redirectTo !== location.pathname) {
    return <Navigate to={redirectTo} replace />
  }

  if (isAuthorized(feature) && !loading) {
    return children
  }

  return (
    <Box sx={{ height: '100vh' }}>
      <Loader />
    </Box>
  )
}
